import React, { ReactNode } from "react"
import { Divider } from "@mui/material"
import './UiSectionTitle.scss'
type IPropsUiSectiontitle = {
    children: ReactNode
}
export const UiSectionTitle  = (props: IPropsUiSectiontitle) => {
    return(
        <div className="ui-section-title">
            <div className="ui-section-title__title">
                {props.children}
            </div>
            <Divider />
        </div>
    )
}